import Modal from '@mui/material/Modal';
import React from 'react';
import { useAppTheme } from '../../../theme/useTheme';
import './Loader.css';

const Loader = ({ loading, bg_papper }) => {
    const { theme } = useAppTheme();
    const loaderColor = theme.palette.primary.main;
    
    return (
        <Modal open={loading} className={`${bg_papper === true ? '' : 'custom_modal_loader'}`}>
            <div style={{ color: loaderColor }} className={`la-line-scale-pulse-out-rapid la-3x position-fixed w-100 h-100 d-flex justify-content-center align-items-center`}>
                <div className="rounded"></div>
                <div className="rounded"></div>
                <div className="rounded"></div>
                <div className="rounded"></div>
                <div className="rounded"></div>
            </div>
        </Modal>
    )
}

export default Loader
